export default "__VITE_ASSET__CWRY_HNR__"